// DropBuy
import React, { useContext, useEffect, useState } from 'react';
import Box from "@mui/material/Box";
import { Grid } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import AppContext from "../../../context/AppProvider";
import InformationMessage from '../../../components/modals/InformationMessage';
import { useDropBuyQuery } from '../../../services/dropBuyApi';
import { DropBuyDataGrid } from './DropBuyDataGrid';
import { v4 as uuidv4 } from 'uuid';

export default function DropBuy() {
  const { message } = useContext(AppContext);
  const {
    data: dropBuyData,
    isSuccess: isDropBuySuccess,
    isLoading: isDropBuyLoading,
  } = useDropBuyQuery();

  const [dropBuy, setDropBuy] = useState([]);

  useEffect(() => {
    if (dropBuyData) {
      const dataWithIds = dropBuyData.map((item) => ({
        ...item,
        _id: uuidv4(), // Generate a unique ID for each item
      }));
      setDropBuy(dataWithIds);
    }
  }, [dropBuyData])

  return (
    <Box sx={{ width: "100%", display: "flex", justifyContent: "center", padding: "0 2em" }}>
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ marginTop: "8em" }}
      >
        {message?.enabled && message?.showOnAllPages && (
          <InformationMessage
            title={message.title}
            message={message.message}
          />
        )}

        <h3 style={{ width: '100%', margin: '0 0 1em 0', color: 'var(--orange)' }}>
          DropBuy Information
        </h3>

        {isDropBuyLoading && <CircularProgress />}

        {isDropBuySuccess && (
          <div style={{ height: "80vh", width: "100%" }}>
            <DropBuyDataGrid dropBuy={dropBuy} />
          </div>
        )}
      </Grid>
    </Box>
  );
}
